import React, { useEffect, useState } from "react";
import { useLogin } from "../../hooks/Login";
import Swal from "sweetalert2";
import image from "../../images/logo.png";
import { Link } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Eye icons from react-icons

function Signin() {
  const { loading, error, message, login } = useLogin();
  const [showPassword, setShowPassword] = useState(false);
  const [imageSize, setImageSize] = useState({ width: 1, height: 1 });

  useEffect(() => {
    const img = new Image();
    img.src = image;
    img.onload = () => {
      setImageSize({ width: img.width, height: img.height });
    };
  }, []);

  // Calculate dynamic width
  const aspectRatio = imageSize.width / imageSize.height;
  const cardWidth = aspectRatio > 1.5 ? "max-w-5xl" : "max-w-3xl";


  useEffect(() => {
    if (error) {
      Swal.fire({
        icon: "error",
        title: "Login Failed",
        text: error,
        confirmButtonColor: "#dc2626",
        timer: 3000,
        timerProgressBar: true,
      });
    }

    if (message) {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: message,
        confirmButtonColor: "#16a34a",
        timer: 3000,
        timerProgressBar: true,
      });
    }
  }, [error, message]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const email = e.target.email.value;
    const password = e.target.password.value;
    login(email, password);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="max-w-6xl  w-full bg-white rounded-xl shadow-xl overflow-hidden lg:flex">
        <div className="w-full  my-auto  p-6 lg:p-8 lg:w-1/2">
          <form className="max-w-md mx-auto" onSubmit={handleSubmit}>
            <h3 className="text-slate-900 text-2xl lg:text-3xl font-bold mb-8 text-center">
              Sign In
            </h3>

            <div className="space-y-6">
              <div>
                <label className="text-sm text-slate-800 font-medium mb-2 block">
                  Email
                </label>
                <input
                  name="email"
                  type="email"
                  required
                  className="bg-slate-100 w-full text-sm text-slate-800 px-4 py-3 rounded-md outline-none border focus:border-[#1A3C34] focus:bg-transparent"
                  placeholder="Enter Email"
                />
              </div>
              <div className="relative">
                <label className="text-sm text-slate-800 font-medium mb-2 block">
                  Password
                </label>
                <input
                  name="password"
                  type={showPassword ? "text" : "password"}
                  required
                  className="bg-slate-100 w-full text-sm text-slate-800 px-4 py-3 rounded-md outline-none border focus:border-[#1A3C34] focus:bg-transparent pr-12"
                  placeholder="Enter Password"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-10 text-gray-500 hover:text-[#1A3C34] focus:outline-none"
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>

              <div className="flex flex-wrap items-center justify-between gap-4">
                <div className="flex items-center">
                  <input
                    id="remember-me"
                    name="remember-me"
                    type="checkbox"
                    className="h-4 w-4 text-[#1A3C34] focus:ring-green-500 border-slate-300 rounded"
                  />
                  <label
                    htmlFor="remember-me"
                    className="ml-3 block text-sm text-slate-500"
                  >
                    Remember me
                  </label>
                </div>
                <div className="text-sm">
                  <Link
                    to="/forgot-password"
                    className="text-[#1A3C34] hover:text-green-500 font-medium transition-colors duration-200"
                  >
                    Forgot Password?
                  </Link>
                </div>
              </div>
            </div>

            <div className="!mt-12">
              <button
                type="submit"
                disabled={loading}
                className={`w-full shadow-xl py-2.5 px-4 text-sm font-semibold rounded text-white bg-[#1A3C34] hover:bg-green-700 focus:outline-none transition-colors duration-200 ${
                  loading ? "opacity-75 cursor-not-allowed" : ""
                }`}
              >
                {loading ? "Logging in..." : "Log in"}
              </button>
            </div>

            <div className="my-4 flex items-center gap-4">
              <hr className="w-full border-slate-300" />
              <p className="text-sm text-slate-800 text-center">or</p>
              <hr className="w-full border-slate-300" />
            </div>

            <div className="space-x-6 flex justify-center">
              <p className="text-lg text-slate-500">
                Don't have an account?
                <Link
                  to="/signup"
                  className="ml-1 text-[#1A3C34] hover:text-green-500 font-medium transition-colors duration-200"
                >
                  Register
                </Link>
              </p>
            </div>
          </form>
        </div>

        <div className="relative hidden lg:flex lg:w-1/2">
          <img
            alt="Sign in poster"
            src={image}
            className="w-full h-auto object-cover"
            style={{ aspectRatio: `${imageSize.width} / ${imageSize.height}` }}
          />
        </div>
      </div>
    </div>
  );
}

export default Signin;
